import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { loadParentDocuments } from './actions';
import List from './List';

class ParentDocuments extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const parentId = this.props.parentId;
		this.props.loadData({ parentId, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleListEvent(listPagination) {
		const parentId = this.props.parentId;
		this.props.loadData({ parentId, ...listPagination });
	}

	render() {
		return (
			<List parentId={this.props.parentId} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} />
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		entities: { parentDocuments } } = state;

	const parentDocumentsPagination = pagination.parentDocuments[ownProps.parentId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: parentDocumentsPagination.ids.map(id => parentDocuments[id]),
		pagination: parentDocumentsPagination
	};
};

ParentDocuments.propTypes = {
	parentId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadParentDocuments
})(ParentDocuments);